import { SportsOverview } from "@/components/SportsOverview";
import { SessionScience } from "@/components/SessionScience";
import { Reveal } from "@/components/Reveal";

export default function ProgramsPage() {
  return (
    <>
      <section className="border-b border-[#E2ECEE] bg-[#0B3B38]">
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-16">
          <span className="text-xs font-extrabold uppercase tracking-wider text-[#FACC15]">Our programs</span>
          <h1 className="mt-2 font-head text-4xl font-extrabold text-white sm:text-5xl">Sports labs for little movers</h1>
          <p className="mt-4 max-w-2xl text-base text-teal-50/80">
            Play-based, science-backed coaching across soccer, basketball, agility and more — for early learning up to Year 2.
          </p>
        </div>
      </section>
      <Reveal><SportsOverview heading="Choose a lab to explore" /></Reveal>
      <Reveal><SessionScience /></Reveal>
    </>
  );
}
